import React, { createContext, useContext, useState, useMemo } from "react";

const STRINGS = {
  en: {
    "app.brand": "THERMAL ACADEMY",
    "app.title": "THERMAL ACADEMY",
    "app.subtitle": "TS 825:2024 · ISO 6946 / DIN · ASTM · GLASER · AI",
    "tab.calc": "Calculation",
    "tab.material": "Material",
    "tab.glaser": "Glaser Analysis",
    "tab.advisor": "Smart advisor",
    "tab.rd": "R&D Lab",
    "tab.fire": "Fire Retardants",
    "tab.suppliers": "Suppliers",
    "tab.library": "Library",
    "tab.ekonomi": "FİNANS",
    "tab.maliyet": "Cost",
    "tab.compare": "Comparison",
    "tab.projects": "My project",
    "tab.standards": "standarts",
    "wizard.country":    "COUNTRY",
    "wizard.climate":    "CLIMATE",
    "wizard.space":      "SPACE",
    "wizard.dimensions": "DIMENSIONS",
    "wizard.insulationType": "INSULATION TYPE",
    "wizard.materials":  "MATERIAL",
    "wizard.cost":       "COST",
    "wizard.finans":     "FİNANS",
    "wizard.suppliers":  "SUPPLIERS",
    "boyut.header":          "Dimensions · Geometric Parameters",
    "boyut.input":           "Input · Dimension Entry",
    "boyut.width":           "Width",
    "boyut.length":          "Length",
    "boyut.height":          "Height",
    "boyut.formula.title":   "Formula Reference",
    "boyut.formula.area":    "Area  A = Width × Length",
    "boyut.formula.volume":  "Volume  V = Width × Length × Height",
    "boyut.formula.wall":    "Wall Area = 2 × (W + L) × H",
    "boyut.calculated":      "Calculated · Results",
    "boyut.area":            "Area",
    "boyut.volume":          "Volume",
    "boyut.wall":            "Wall Area",
    "projects.title":              "My Projects",
    "projects.saveCurrent":        "Save Current Project",
    "projects.savedHint":          "Save all project data (layers, climate, conditions, R/U metrics, AI analysis) with one click and reload later.",
    "projects.empty":              "No saved projects yet. Click \"Save Current Project\" above.",
    "projects.load":               "Load",
    "projects.delete":             "Delete",
    "projects.toast.saved":        "Project saved",
    "projects.toast.saveFail":     "Could not save: ",
    "projects.toast.loaded":       "loaded",
    "projects.toast.loadFail":     "Could not load project",
    "projects.toast.deleted":      "Deleted",
    "projects.toast.deleteFail":   "Could not delete",
    "advisor.hero.kicker":         "CLIMATE-SMART SELECTION ADVISOR",
    "advisor.hero.headline":       "Smart Insulation Advisor",
    "advisor.hero.subtitle":       "Scores insulation material classes against 5 criteria — thermal · fire · condensation · durability · cost — based on Turkish city + building element + building height context.",
    "advisor.params.title":        "Project Context",
    "advisor.params.city":         "City",
    "advisor.params.element":      "Building Element",
    "advisor.params.height":       "Building Height (m)",
    "advisor.params.fireZone":     "Fire-Risk Zone",
    "advisor.params.fireHint":     "Hospital / school / mall",
    "advisor.params.zonePrefix":   "Zone",
    "advisor.elem.extwall":        "External Wall",
    "advisor.elem.roof":           "Roof",
    "advisor.elem.floor":          "Floor",
    "advisor.elem.intwall":        "Internal Wall",
    "advisor.criterion.thermal":   "Thermal",
    "advisor.criterion.fire":      "Fire",
    "advisor.criterion.cond":      "Condensation",
    "advisor.criterion.dura":      "Durability",
    "advisor.criterion.cost":      "Cost",
    "advisor.loading":             "Analyzing context...",
    "advisor.context.title":       "Geographic Context",
    "advisor.context.zoneTag":     "TS 825:2024 ZONE",
    "advisor.context.utarget":     "U-TARGET",
    "advisor.context.tags":        "STATUS TAGS",
    "advisor.tag.highrise":        "HIGH-RISE",
    "advisor.tag.coastal":         "COASTAL",
    "advisor.tag.cold":            "COLD",
    "advisor.tag.firestrict":      "FIRE-STRICT",
    "advisor.winner.kicker":       "PROFESSOR'S PICK · RECOMMENDED CHOICE",
    "advisor.winner.brand":        "Brand example:",
    "advisor.winner.totalScore":   "TOTAL SCORE",
    "advisor.winner.thickness":    "RECOMMENDED THICKNESS",
    "advisor.winner.thicknessFor": "to meet U={u} W/m²K target",
    "advisor.winner.pros":         "PROS",
    "advisor.winner.cons":         "CAUTION",
    "advisor.radar.title":         "Multi-Criteria Comparison · Radar",
    "advisor.bar.title":           "Total Score Ranking",
    "advisor.table.title":         "Detailed Ranking",
    "advisor.table.weights":       "Weights:",
    "advisor.table.material":      "MATERIAL",
    "advisor.table.total":         "TOTAL",
    "advisor.table.rec":           "RECOMMENDATION",
    "advisor.table.blocked":       "BLOCKED · Fire",
    "matdash.insulation":          "Insulation Materials",
    "header.standards": "Standards",
    "academic.title": "R&D Material Design Lab",
    "academic.subtitle": "Experimental data and predictive material design tools across EPS, Rockwool, Glasswool, and PUR/PIR systems.",
    "advisor.title": "Climate-Smart Insulation Advisor",
    "advisor.subtitle": "Ranks insulation classes across 5 criteria based on Turkish city + building element + height context.",
    "advisor.winner": "Professor's Choice",
    "advisor.thickness": "Recommended Thickness",
    "advisor.pros": "Pros",
    "advisor.cons": "Caution",
    "glaser.title": "Interactive Glaser Analysis",
    "glaser.subtitle": "EN 13788 temperature + vapor pressure gradient · hover for exact values.",
    "common.save": "Save",
    "common.load": "Load",
    "common.delete": "Delete",
    "common.download": "Download",
    "common.disclaimer": "Predicted values. Laboratory validation required.",
    "footer": "THERMAL ACADEMY · TS 825:2024 / ISO 6946 / DIN 4108 / ASTM C518 / EN 13788 · v7.0",

    "header.day":   "Day",
    "header.night": "Night",
    "app.subtitle.tagline": "AI-Powered Smart Platform which is Giving Direction to the Future of Global Insulation",

    "metrics.title":         "Thermal Performance",
    "metrics.realtime":      "REAL-TIME · TS 825:2024",
    "metrics.totalR":        "TOTAL R-VALUE",
    "metrics.uValue":        "U-VALUE",
    "metrics.indoorT":       "INDOOR °C",
    "metrics.outdoorT":      "OUTDOOR °C",
    "metrics.indoorRH":      "INDOOR %",
    "metrics.outdoorRH":     "OUTDOOR %",
    "metrics.noCondensation":  "NO CONDENSATION RISK",
    "metrics.condensationRisk":"CONDENSATION RISK",

    "layers.title":      "Layers (Inside → Outside)",
    "layers.add":        "ADD LAYER",
    "layers.material":   "MATERIAL",
    "layers.thickness":  "d (m)",
    "layers.lambda":     "λ",
    "layers.action":     "ACTION",

    "library.title":     "Material Library",
    "library.custom":    "CUSTOM",
    "library.filter":    "Filter (name / category)",
    "library.use":       "USE",

    "draw.title":        "Technical Cross-Section",
    "draw.total":        "TOTAL",

    "report.title":      "OFFICIAL REPORT",
    "report.generate":   "GENERATE PDF REPORT",
    "report.contents":   "Cover + TOC + Academic Validation",
    "report.summary":    "Cover page, table of contents, materials & methodology, layer table, Glaser charts, AI expert analysis & academic validation across 6+ pages.",

    "glaser.tooltip.temp":   "Temperature °C",
    "glaser.tooltip.dewpoint": "Dew Point",
    "glaser.interactive":    "INTERACTIVE · HOVER",

    "map.title":           "Country Drill-Down · Suppliers Map",
    "map.world":           "World",
    "map.city":            "City",
    "map.cities":          "Cities",
    "map.suppliers":       "Suppliers",
    "map.firms":           "firms",
    "map.firm":            "firm",
    "map.step1":           "STEP 1 →",
    "map.step1Hint":       "Use the dropdown above to pick a country. Its cities will appear as white markers.",
    "map.step2":           "STEP 2 →",
    "map.step2Hint":       "Click a green city marker. Its suppliers appear on the right.",
    "map.step3":           "STEP 3 →",
    "map.step3Hint":       "Green markers show suppliers in",
    "map.selectCountry":   "Select a country",
    "map.selectCountryHint":"Pick a country on the map to begin.",
    "map.selectCity":      "Select a city",
    "map.selectCityHint":  "Click a green city marker on the map. Its suppliers will appear here.",
    "map.noSuppliers":     "No suppliers yet",
    "map.noSuppliersHint": "No registered suppliers for this city.",
    "map.district":        "District",
    "map.districts":       "Districts",
    "map.districtsHint":   "Click an orange district marker to filter.",
    "map.allDistricts":    "All districts",
    "map.pickCountry":     "Pick a country",
    "map.step1b":          "STEP 1B →",
    "map.clickRedPin":     "Click the red pin on",
    "map.toShowCities":    "to reveal its cities (green markers).",
    "map.clickToDrillDown":"click to reveal cities",
    "common.clear":        "Clear",
    "calc.condensation.surface":  "Surface",
    "calc.condensation.layer":    "Interlayer",
    "calc.condensation.dew":      "Dew",
    "calc.condensation.inner":    "Inner surface",
    "calc.condensation.risky":    "RISK",
    "calc.condensation.ok":       "OK",
    "layers.empty":               "No layers yet. Start with + Layer.",
    "layers.newLayer":            "New layer",
    "library.empty":              "No matching materials",
    "library.add.title":          "Add Custom Material",
    "library.add.name":           "Name",
    "library.add.lambda":         "λ (W/mK)",
    "library.add.mu":             "μ",
    "library.add.category":       "Category",
    "library.add.brand":          "Brand",
    "library.add.description":    "Description",
    "library.add.toastOk":        "Material added",
    "library.add.toastErr":       "Failed to add material",
    "library.add.deleted":        "Deleted",
    "library.add.deleteErr":      "Delete failed",
    "library.add.required":       "Name and λ are required",
    "library.add.default.category":"Insulation",
    "glaser.title2":              "Glaser Analysis",
    "glaser.label.airIn":         "Indoor air",
    "glaser.label.surfaceIn":     "Indoor surface",
    "glaser.label.surfaceOut":    "Outdoor surface",
    "glaser.legend.temperature":  "Temperature °C",
    "glaser.legend.dew":          "Dew Point",
    "glaser.legend.vapor":        "Vapor Pressure (Pa)",
    "glaser.legend.saturation":   "Saturation Pressure (Pa)",
    "glaser.condensationPoints":  "Condensation points",
    "glaser.totalSd":             "total",
    "draw.toplam":                "TOTAL",
    "draw.scale":                 "SCALE 1:2",
    "draw.legend.insulation":     "Insulation",
    "draw.legend.wall":           "Wall",
    "draw.legend.structural":     "Structural",
    "draw.legend.plaster":        "Plaster",
    "draw.legend.membrane":       "Membrane",
    "draw.legend.cladding":       "Cladding",
    "ai.title":                   "AI Expert Analysis",
    "ai.btn.analyzing":           "Analyzing...",
    "ai.btn.run":                 "Analyze",
    "ai.intro":                   "Get an AI expert analysis of the current layers — alternative material suggestions, weaknesses, mitigation methods and installation tips.",
    "ai.thinking":                "Claude Haiku 4.5 is analysing...",
    "ai.summary":                 "SUMMARY",
    "ai.recommended":             "Recommended Materials",
    "ai.drawbacks":               "Weaknesses & Mitigations",
    "ai.mitigation":              "MITIGATION",
    "ai.installTips":             "Installation Tips",
    "rdLab.note.title":           "Teacher's Note · Professor's Insights · Academic Research Commentary",
    "rdLab.note.kicker":          "ACADEMIC RESEARCH",
    "rdLab.note.lab":             "Building Physics & Materials Science Laboratory",
    "rdLab.note.hnt.title":       "Teacher's Note · HNT Clay",
    "rdLab.note.hnt.body":        "Halloysite Nanotubes (HNT) are the natural nanostructured form of the clay family — tubular particles with inner diameters of 15–30 nm and outer diameters of 50–70 nm. When added to an EPS matrix at 2–5%:",
    "rdLab.note.hnt.b1.pre":      "→ Reduces fire spread via a silicate barrier by",
    "rdLab.note.hnt.b1.val":      "30%+",
    "rdLab.note.hnt.b2.pre":      "→ Increases flexural strength by",
    "rdLab.note.hnt.b2.val":      "18–25%",
    "rdLab.note.hnt.b3":          "→ Limits water vapour diffusion (μ ↑)",
    "rdLab.note.hnt.b4":          "→ Natural resource — low environmental impact, recyclable",
    "rdLab.note.hnt.italic":      "In our doctoral research, HNT-modified EPS was found to develop a carbonised layer 2.4× more efficiently than standard EPS at temperatures above 250 °C under flame exposure.",
    "rdLab.note.bor.title":       "Teacher's Note · Boron Compounds",
    "rdLab.note.bor.body.pre":    "Türkiye holds",
    "rdLab.note.bor.body.val":    "73%",
    "rdLab.note.bor.body.post":   "of the world's boron reserves. Zinc borate (Zn₃B₆O₁₂·H₂O) and boric acid (H₃BO₃) are high-performance flame retardants for EPS:",
    "rdLab.note.bor.b1":          "→ Forms a glassy boroxide layer above 300 °C",
    "rdLab.note.bor.b2.pre":      "→ Can increase LOI by",
    "rdLab.note.bor.b2.val":      "+12–15 points",
    "rdLab.note.bor.b3.pre":      "→ Thermal stability (TGA) shifts by",
    "rdLab.note.bor.b3.val":      "+40 °C",
    "rdLab.note.bor.b4.pre":      "→ Reduces smoke production (SPR) by",
    "rdLab.note.bor.b4.val":      "50%+",
    "rdLab.note.bor.b5":          "→ Halogen-free — RoHS / REACH compliant",
    "rdLab.note.bor.italic":      "Strategic insight: Türkiye's boron wealth lowers import dependency for domestically produced EPS panels, providing a strong cost advantage.",
    "rdLab.note.peer":            "PEER-REVIEWED · ACADEMIC",
    "header.coming_soon":         "Coming Soon",
    "header.coming_soon_short":   "Soon",
    "header.lang_toast":          "This language will be available soon. Showing English.",
    "header.choose_lang":         "Choose language",
    "rdLab.hero.kicker":          "R&D · ACADEMIC RESEARCH DATABASE",
    "rdLab.hero.title":           "Academic Analysis & Test Results",
    "rdLab.hero.desc":            "Experimental data obtained within the scope of academic research. Compliant with ISO 5660-1 (Cone Calorimeter), ASTM D3801 (UL94), ISO 4589-2 (LOI), TS EN 12089 (Flexural) and TS EN 1607 (Tensile) standards.",
    "rdLab.db.label":             "DATABASE · {n} MATERIALS · Click to load",
    "rdLab.db.empty":             "Pick a material above to load detail data.",
    "rdLab.mech.title":           "Mechanical Properties · Stress-Strain Curve",
    "rdLab.mech.flexural":        "FLEXURAL",
    "rdLab.mech.tensile":         "TENSILE",
    "rdLab.mech.compressive":     "COMPRESSIVE",
    "rdLab.mech.emodulus":        "E-MODULUS",
    "rdLab.mech.density":         "DENSITY",
    "rdLab.mech.note":            "Curve represents the average of 5 specimens. The post-yield region reveals the material's ductile vs. brittle character.",
    "rdLab.fire.title":           "Fire Performance · Cone Calorimeter (ISO 5660-1)",
    "rdLab.fire.service":         "SERVICE T.",
    "rdLab.fire.ignition":        "IGNITION",
    "rdLab.fire.note":            "The Cone Calorimeter test is performed at 50 kW/m² irradiance. A lower pHRR (peak Heat Release Rate) reduces flame spread velocity.",
    "teachersNoteContent":        "Teacher's Note: WR-Tech impregnation significantly improves fire performance and moisture protection. The synergy between bio-binders and flame retardants is verified through academic models.",
    "eps.header.title":           "EPS R&D Model · Advanced Additive Library",
    "pricing.header":             "Estimated Cost · Multi-Currency",
    "pricing.summary.perKg":      "TOTAL / KG",
    "pricing.summary.panel":      "10 cm PANEL (m²)",
    "pricing.summary.output":     "100 m² OUTPUT",
    "eps.sensitivity.title":      "Sensitivity Trends",
    "rockwool.title":             "Rockwool Module · WR-Tech Hydrophobic Resin",
    "rockwool.desc":              "WR-Tech (Water-Repellent) silicone-based resin impregnation hydrophobises the mineral wool fibre surface, dramatically reducing the short-term water absorption value of EN 13472. It also strengthens the char-layer formation in the UL 1709 hydrocarbon pool-fire test.",
    "rockwool.slider":            "WR-Tech Resin (%)",
    "rockwool.slider.hint":       "0% (untreated) → 8% (premium WR3)",
    "rockwool.cell.water":        "WATER ABSORPTION (EN 13472)",
    "rockwool.cell.water.unit":   "kg/m² · 24h",
    "rockwool.cell.ul1709":       "UL 1709 PROTECTION",
    "rockwool.cell.ul1709.unit":  "minutes (Tcrit)",
    "rockwool.cell.density":      "DENSITY",
    "rockwool.chart.water":       "Water Absorption Curve · EN 13472",
    "rockwool.chart.fire":        "Fire Protection · UL 1709",
    "rockwool.chart.unit.min":    "min",
    "rockwool.note.title":        "Teacher's Note · WR-Tech and Fire Performance",
    "rockwool.note.body":         "2-4% WR-Tech resin impregnation preserves the long-term thermal insulation performance of stone wool by 20-30% (preventing moisture-uptake losses). In the UL 1709 hydrocarbon fire test, the resin char layer delivers 90+ minutes of protection — critical for offshore platforms and petrochemical facilities.",
    "compare.params":           "Comparison Parameters",
    "compare.area":             "Area (m²)",
    "compare.electricity":      "Electricity (TL/kWh)",
    "compare.heating.duration": "Annual Heating Duration",
    "compare.layer":            "Layer",
    "compare.col.material":     "MATERIAL",
    "compare.col.delete":       "DELETE",
    "compare.cell.r":           "R-VALUE",
    "compare.cell.u":           "U-VALUE",
    "compare.result":           "Result Comparison",
    "compare.winning":          "WINNING: SCENARIO",
    "compare.annual":           "Annual (kWh)",
    "compare.savings":          "SAVINGS / YEAR",
    "compare.calc":             "Calculation: Q = U · A · HDD · 24 / 1000 (kWh/year). 20-year projection: {value} potential savings · energy price inflation not included.",
    "compare.newlayer":         "New Layer",
  },
  tr: {
    "app.brand": "THERMAL ACADEMY",
    "app.title": "THERMAL ACADEMY",
    "app.subtitle": "TS 825:2024 · ISO 6946 / DIN · ASTM · GLASER · AI",
    "tab.calc": "Hesaplama",
    "tab.material": "Malzeme",
    "tab.glaser": "Glaser Analizi",
    "tab.advisor": "Akıllı Seçim",
    "tab.rd": "R&D Lab",
    "tab.fire": "Yangın Geciktiriciler",
    "tab.suppliers": "Tedarikçiler",
    "tab.library": "Kütüphane",
    "tab.ekonomi": "FİNANS",
    "tab.maliyet": "Maliyet",
    "tab.compare": "Karşılaştırma",
    "tab.projects": "Projelerim",
    "tab.standards": "standarts",
    "wizard.country":    "ÜLKE",
    "wizard.climate":    "İKLİM",
    "wizard.space":      "MEKAN",
    "wizard.dimensions": "EBATLAR",
    "wizard.insulationType": "İZOLASYON TÜRÜ",
    "wizard.materials":  "MALZEME",
    "wizard.cost":       "MALİYET",
    "wizard.finans":     "FİNANS",
    "wizard.suppliers":  "TEDARİKÇİLER",
    "boyut.header":          "Ebatlar · Geometrik Parametreler",
    "boyut.input":           "Giriş · Boyut Girişi",
    "boyut.width":           "Genişlik",
    "boyut.length":          "Uzunluk",
    "boyut.height":          "Yükseklik",
    "boyut.formula.title":   "Formül Referansı",
    "boyut.formula.area":    "Alan  A = Genişlik × Uzunluk",
    "boyut.formula.volume":  "Hacim  V = Genişlik × Uzunluk × Yükseklik",
    "boyut.formula.wall":    "Duvar Alanı = 2 × (G + U) × Y",
    "boyut.calculated":      "Hesaplanan · Sonuçlar",
    "boyut.area":            "Alan",
    "boyut.volume":          "Hacim",
    "boyut.wall":            "Duvar Alanı",
    "projects.title":              "Projelerim",
    "projects.saveCurrent":        "Mevcut Projeyi Kaydet",
    "projects.savedHint":          "Tüm proje verilerini (katmanlar, iklim, koşullar, R/U metrikleri, AI analizi) tek tıkla kaydedin ve daha sonra yükleyin.",
    "projects.empty":              "Henüz kaydedilmiş proje yok. Yukarıdan \"Mevcut Projeyi Kaydet\"e tıklayın.",
    "projects.load":               "Yükle",
    "projects.delete":             "Sil",
    "projects.toast.saved":        "Proje kaydedildi",
    "projects.toast.saveFail":     "Kaydedilemedi: ",
    "projects.toast.loaded":       "yüklendi",
    "projects.toast.loadFail":     "Proje yüklenemedi",
    "projects.toast.deleted":      "Silindi",
    "projects.toast.deleteFail":   "Silinemedi",
    "advisor.hero.kicker":         "İKLİM-AKILLI MALZEME TAVSİYESİ",
    "advisor.hero.headline":       "Akıllı Yalıtım Tavsiyesi",
    "advisor.hero.subtitle":       "Türk şehri + yapı elemanı + bina yüksekliği bağlamına göre yalıtım malzemesi sınıflarını 5 kritere göre puanlar: termal · yangın · yoğuşma · dayanıklılık · maliyet.",
    "advisor.params.title":        "Proje Bağlamı",
    "advisor.params.city":         "Şehir",
    "advisor.params.element":      "Yapı Elemanı",
    "advisor.params.height":       "Bina Yüksekliği (m)",
    "advisor.params.fireZone":     "Yangın Riskli Bölge",
    "advisor.params.fireHint":     "Hastane / okul / AVM",
    "advisor.params.zonePrefix":   "Bölge",
    "advisor.elem.extwall":        "Dış Duvar",
    "advisor.elem.roof":           "Çatı",
    "advisor.elem.floor":          "Döşeme",
    "advisor.elem.intwall":        "İç Duvar",
    "advisor.criterion.thermal":   "Termal",
    "advisor.criterion.fire":      "Yangın",
    "advisor.criterion.cond":      "Yoğuşma",
    "advisor.criterion.dura":      "Dayanıklılık",
    "advisor.criterion.cost":      "Maliyet",
    "advisor.loading":             "Bağlam analiz ediliyor...",
    "advisor.context.title":       "Coğrafi Bağlam",
    "advisor.context.zoneTag":     "TS 825:2024 BÖLGE",
    "advisor.context.utarget":     "U-HEDEF",
    "advisor.context.tags":        "DURUM ETİKETLERİ",
    "advisor.tag.highrise":        "YÜKSEK YAPI",
    "advisor.tag.coastal":         "KIYI",
    "advisor.tag.cold":            "SOĞUK",
    "advisor.tag.firestrict":      "YANGIN-SIKI",
    "advisor.winner.kicker":       "HOCA'NIN SEÇİMİ · ÖNERİLEN MALZEME",
    "advisor.winner.brand":        "Marka örneği:",
    "advisor.winner.totalScore":   "TOPLAM PUAN",
    "advisor.winner.thickness":    "ÖNERİLEN KALINLIK",
    "advisor.winner.thicknessFor": "U={u} W/m²K hedefi için",
    "advisor.winner.pros":         "AVANTAJ",
    "advisor.winner.cons":         "DİKKAT",
    "advisor.radar.title":         "Çok-Kriterli Karşılaştırma · Radar",
    "advisor.bar.title":           "Toplam Puan Sıralaması",
    "advisor.table.title":         "Detaylı Sıralama",
    "advisor.table.weights":       "Ağırlıklar:",
    "advisor.table.material":      "MALZEME",
    "advisor.table.total":         "TOPLAM",
    "advisor.table.rec":           "ÖNERİ",
    "advisor.table.blocked":       "YASAK · Yangın",
    "matdash.insulation":          "İzolasyon Malzemeleri",
    "header.standards": "Standartlar",
    "academic.title": "Ar-Ge Malzeme Tasarım Lab",
    "academic.subtitle": "EPS · Taş Yünü · Cam Yünü · PUR/PIR sistemleri için deneysel veri ve tahminsel tasarım araçları.",
    "advisor.title": "İklim Bazlı Akıllı Yalıtım Tavsiyesi",
    "advisor.subtitle": "Türk şehri + yapı elemanı + bina yüksekliği bağlamına göre 5 kritere göre puanlar.",
    "advisor.winner": "Hoca'nın Seçimi",
    "advisor.thickness": "Önerilen Kalınlık",
    "advisor.pros": "Avantaj",
    "advisor.cons": "Dikkat",
    "glaser.title": "İnteraktif Glaser Analizi",
    "glaser.subtitle": "EN 13788 sıcaklık + buhar basıncı gradyanı · değerler için üzerine gelin.",
    "common.save": "Kaydet",
    "common.load": "Yükle",
    "common.delete": "Sil",
    "common.download": "İndir",
    "common.disclaimer": "Tahmini değerler. Laboratuvar onayı gereklidir.",
    "footer": "THERMAL ACADEMY · TS 825:2024 / ISO 6946 / DIN 4108 / ASTM C518 / EN 13788 · v7.0",

    "header.day":   "Gündüz",
    "header.night": "Gece",
    "app.subtitle.tagline": "AI-Powered Smart Platform which is Giving Direction to the Future of Global Insulation",

    "metrics.title":         "Termal Performans",
    "metrics.realtime":      "GERÇEK ZAMANLI · TS 825:2024",
    "metrics.totalR":        "TOPLAM R-DEĞERİ",
    "metrics.uValue":        "U-DEĞERİ",
    "metrics.indoorT":       "İÇ °C",
    "metrics.outdoorT":      "DIŞ °C",
    "metrics.indoorRH":      "İÇ %",
    "metrics.outdoorRH":     "DIŞ %",
    "metrics.noCondensation":  "YOĞUŞMA RİSKİ YOK",
    "metrics.condensationRisk":"YOĞUŞMA RİSKİ",

    "layers.title":      "Katmanlar (İçten Dışa)",
    "layers.add":        "KATMAN",
    "layers.material":   "MALZEME",
    "layers.thickness":  "D (M)",
    "layers.lambda":     "Λ",
    "layers.action":     "İŞLEM",

    "library.title":     "Malzeme Kütüphanesi",
    "library.custom":    "ÖZEL",
    "library.filter":    "Filtrele (isim / kategori)",
    "library.use":       "KULLAN",

    "draw.title":        "Teknik Kesit",
    "draw.total":        "TOPLAM",

    "report.title":      "RESMİ RAPOR",
    "report.generate":   "PDF RAPOR OLUŞTUR",
    "report.contents":   "Kapak + TOC + Akademik Doğrulama",
    "report.summary":    "Kapak sayfası, içindekiler, materyal & yöntem, katman tablosu, Glaser grafikleri, AI uzman analizi ve akademik doğrulama dahil 6+ sayfa.",

    "glaser.tooltip.temp":     "Sıcaklık °C",
    "glaser.tooltip.dewpoint": "Çiy Noktası",
    "glaser.interactive":      "İNTERAKTİF · HOVER",

    "map.title":           "Ülke Detayı · Tedarikçi Haritası",
    "map.world":           "Dünya",
    "map.city":            "Şehir",
    "map.cities":          "Şehirler",
    "map.suppliers":       "Tedarikçiler",
    "map.firms":           "firma",
    "map.firm":            "firma",
    "map.step1":           "ADIM 1 →",
    "map.step1Hint":       "Yukarıdaki açılır listeden bir ülke seçin. Şehirleri beyaz işaret olarak görünür.",
    "map.step2":           "ADIM 2 →",
    "map.step2Hint":       "Yeşil bir şehir işaretine tıklayın. Tedarikçileri sağda görünür.",
    "map.step3":           "ADIM 3 →",
    "map.step3Hint":       "Yeşil işaretler şehirdeki tedarikçileri gösterir:",
    "map.selectCountry":   "Bir ülke seçin",
    "map.selectCountryHint":"Başlamak için haritada bir ülkeye tıklayın.",
    "map.selectCity":      "Bir şehir seçin",
    "map.selectCityHint":  "Haritada yeşil bir şehir işaretine tıklayın. Tedarikçiler burada görünür.",
    "map.noSuppliers":     "Henüz tedarikçi yok",
    "map.noSuppliersHint": "Bu şehirde kayıtlı tedarikçi bulunmuyor.",
    "map.district":        "İlçe",
    "map.districts":       "İlçeler",
    "map.districtsHint":   "Filtrelemek için turuncu ilçe işaretine tıklayın.",
    "map.allDistricts":    "Tüm ilçeler",
    "map.pickCountry":     "Ülke seçin",
    "map.step1b":          "ADIM 1B →",
    "map.clickRedPin":     "Kırmızı işarete tıklayın:",
    "map.toShowCities":    "şehirleri (yeşil işaretler) görmek için.",
    "map.clickToDrillDown":"şehirleri görmek için tıklayın",
    "common.clear":        "Temizle",
    "calc.condensation.surface":  "Yüzey",
    "calc.condensation.layer":    "Ara katman",
    "calc.condensation.dew":      "Çiy",
    "calc.condensation.inner":    "İç yüzey",
    "calc.condensation.risky":    "RİSKLİ",
    "calc.condensation.ok":       "OK",
    "layers.empty":               "Henüz katman yok. + Katman ile başlayın.",
    "layers.newLayer":            "Yeni katman",
    "library.empty":              "Eşleşen malzeme yok",
    "library.add.title":          "Özel Malzeme Ekle",
    "library.add.name":           "İsim",
    "library.add.lambda":         "λ (W/mK)",
    "library.add.mu":             "μ",
    "library.add.category":       "Kategori",
    "library.add.brand":          "Marka",
    "library.add.description":    "Açıklama",
    "library.add.toastOk":        "Malzeme eklendi",
    "library.add.toastErr":       "Eklenemedi",
    "library.add.deleted":        "Silindi",
    "library.add.deleteErr":      "Silinemedi",
    "library.add.required":       "İsim ve λ gerekli",
    "library.add.default.category":"Yalıtım",
    "glaser.title2":              "Glaser Analizi",
    "glaser.label.airIn":         "İç hava",
    "glaser.label.surfaceIn":     "İç yüzey",
    "glaser.label.surfaceOut":    "Dış yüzey",
    "glaser.legend.temperature":  "Sıcaklık °C",
    "glaser.legend.dew":          "Çiy Noktası",
    "glaser.legend.vapor":        "Buhar Basıncı (Pa)",
    "glaser.legend.saturation":   "Doymuş Basınç (Pa)",
    "glaser.condensationPoints":  "Yoğuşma noktası",
    "glaser.totalSd":             "toplam",
    "draw.toplam":                "TOPLAM",
    "draw.scale":                 "ÖLÇEK 1:2",
    "draw.legend.insulation":     "Yalıtım",
    "draw.legend.wall":           "Duvar",
    "draw.legend.structural":     "Yapısal",
    "draw.legend.plaster":        "Sıva",
    "draw.legend.membrane":       "Membran",
    "draw.legend.cladding":       "Kaplama",
    "ai.title":                   "AI Uzman Analizi",
    "ai.btn.analyzing":           "Analiz...",
    "ai.btn.run":                 "Analiz Et",
    "ai.intro":                   "Mevcut katmanlar için AI uzman analizi alın: alternatif malzeme önerileri, zayıflıklar, azaltma yöntemleri ve montaj ipuçları.",
    "ai.thinking":                "Claude Haiku 4.5 analiz ediyor...",
    "ai.summary":                 "ÖZET",
    "ai.recommended":             "Önerilen Malzemeler",
    "ai.drawbacks":               "Zayıflıklar & Azaltma Yöntemleri",
    "ai.mitigation":              "AZALTMA",
    "ai.installTips":             "Uygulama İpuçları",
    "rdLab.note.title":           "Hoca'nın Notu · Professor's Insights · Akademik Araştırma Yorumu",
    "rdLab.note.kicker":          "AKADEMİK ARAŞTIRMA",
    "rdLab.note.lab":             "Yapı Fiziği & Malzeme Bilimi Laboratuvarı",
    "rdLab.note.hnt.title":       "Hoca'nın Notu · HNT Kili",
    "rdLab.note.hnt.body":        "Halloysit Nanotüpleri (HNT), doğal kil grubunun nanoyapısal formudur — iç çapı 15-30 nm, dış çapı 50-70 nm tüpsel partiküller. EPS matrisine %2-5 oranında eklendiğinde:",
    "rdLab.note.hnt.b1.pre":      "→ Silikat bariyeri ile yangın yayılımını",
    "rdLab.note.hnt.b1.val":      "%30+",
    "rdLab.note.hnt.b2.pre":      "→ Eğilme dayanımını",
    "rdLab.note.hnt.b2.val":      "%18-25",
    "rdLab.note.hnt.b3":          "→ Su buhar difüzyonunu sınırlar (μ ↑)",
    "rdLab.note.hnt.b4":          "→ Doğal kaynak — düşük çevresel etki, geri dönüştürülebilir",
    "rdLab.note.hnt.italic":      "Doktora çalışmamızda HNT katkılı EPS'in 250 °C üzerinde alev karşısında karbonize tabaka oluşturma kapasitesi standart EPS'e göre 2.4× yüksek bulunmuştur.",
    "rdLab.note.bor.title":       "Hoca'nın Notu · Bor Bileşikleri",
    "rdLab.note.bor.body.pre":    "Türkiye, dünya bor rezervinin",
    "rdLab.note.bor.body.val":    "%73'üne",
    "rdLab.note.bor.body.post":   "sahiptir. Çinko borat (Zn₃B₆O₁₂·H₂O) ve borik asit (H₃BO₃) EPS için yüksek performanslı yangın geciktiricidir:",
    "rdLab.note.bor.b1":          "→ 300 °C üzerinde camsı boroksit tabakası oluşturur",
    "rdLab.note.bor.b2.pre":      "→ LOI'yi",
    "rdLab.note.bor.b2.val":      "+12-15 puan",
    "rdLab.note.bor.b3.pre":      "→ Termal stabilite (TGA)",
    "rdLab.note.bor.b3.val":      "+40 °C",
    "rdLab.note.bor.b4.pre":      "→ Duman üretimini (SPR)",
    "rdLab.note.bor.b4.val":      "%50+",
    "rdLab.note.bor.b5":          "→ Halojensiz — RoHS / REACH uyumlu",
    "rdLab.note.bor.italic":      "Stratejik öneri: Türkiye'nin bor zenginliği, yerli üretim EPS panellerinde ithalat-bağımlılığı düşürerek maliyet avantajı sağlar.",
    "rdLab.note.peer":            "HAKEMLİ · AKADEMİK",
    "header.coming_soon":         "Yakında",
    "header.coming_soon_short":   "Yakında",
    "header.lang_toast":          "Bu dil yakında kullanıma sunulacaktır. Şimdilik İngilizce gösteriliyor.",
    "header.choose_lang":         "Dil seçimi",
    "rdLab.hero.kicker":          "R&D · AKADEMİK ARAŞTIRMA VERİTABANI",
    "rdLab.hero.title":           "Akademik Analiz & Test Verileri",
    "rdLab.hero.desc":            "Akademik araştırma kapsamında elde edilen deneysel veriler. ISO 5660-1 (Cone Calorimeter), ASTM D3801 (UL94), ISO 4589-2 (LOI), TS EN 12089 (Eğilme), TS EN 1607 (Çekme) standartlarına uygun.",
    "rdLab.db.label":             "VERİTABANI · {n} MALZEME · Click to load",
    "rdLab.db.empty":             "Yukarıdaki listeden bir malzeme seçin · Pick a material above to load detail data.",
    "rdLab.mech.title":           "Mekanik Özellikler · Stress-Strain Eğrisi",
    "rdLab.mech.flexural":        "EĞİLME",
    "rdLab.mech.tensile":         "ÇEKME",
    "rdLab.mech.compressive":     "BASMA",
    "rdLab.mech.emodulus":        "E-MODÜL",
    "rdLab.mech.density":         "YOĞUNLUK",
    "rdLab.mech.note":            "Eğri, ortalama 5 numune ortalamasıdır. Akma sonrası bölge, malzemenin sünek/gevrek karakterini gösterir.",
    "rdLab.fire.title":           "Yangın Performansı · Cone Calorimeter (ISO 5660-1)",
    "rdLab.fire.service":         "SERVİS SIC.",
    "rdLab.fire.ignition":        "TUTUŞMA",
    "rdLab.fire.note":            "Cone Calorimeter testi 50 kW/m² ışınım altında yapılır. pHRR (peak Heat Release Rate) düşük olması yangın yayılım hızını azaltır.",
    "teachersNoteContent":        "Hocanın Notu: WR-Tech emprenye işlemi yangın performansını ve nem korumasını önemli ölçüde iyileştirir. Biyo-bağlayıcılar ve alev geciktiriciler arasındaki sinerji akademik modellerle doğrulanmıştır.",
    "eps.header.title":           "EPS Ar-Ge Modeli · Advanced Additive Library",
    "pricing.header":             "Tahmini Maliyet · Multi-Currency",
    "pricing.summary.perKg":      "TOPLAM / KG",
    "pricing.summary.panel":      "10 cm PANEL (m²)",
    "pricing.summary.output":     "100 m² ÇIKIŞ",
    "eps.sensitivity.title":      "Hassasiyet Analizi · Sensitivity Trends",
    "rockwool.title":             "Rockwool Modülü · WR-Tech Hidrofobik Reçine",
    "rockwool.desc":              "WR-Tech (Water-Repellent) silikon-bazlı reçine emdirme, mineral yün liflerinin yüzeyini hidrofobikleştirerek EN 13472 kısa-süreli su emme değerini dramatik şekilde azaltır. UL 1709 hidrokarbon havuz yangını testinde de char tabakası oluşumunu güçlendirir.",
    "rockwool.slider":            "WR-Tech Reçine (%)",
    "rockwool.slider.hint":       "0% (untreated) → 8% (premium WR3)",
    "rockwool.cell.water":        "SU EMME (EN 13472)",
    "rockwool.cell.water.unit":   "kg/m² · 24h",
    "rockwool.cell.ul1709":       "UL 1709 KORUMA",
    "rockwool.cell.ul1709.unit":  "dakika (Tcrit)",
    "rockwool.cell.density":      "YOĞUNLUK",
    "rockwool.chart.water":       "Su Emme Eğrisi · EN 13472",
    "rockwool.chart.fire":        "Yangın Koruma · UL 1709",
    "rockwool.chart.unit.min":    "dak",
    "rockwool.note.title":        "Hoca'nın Notu · WR-Tech ve Yangın Performansı",
    "rockwool.note.body":         "%2-4 WR-Tech reçine emdirme, taş yününün uzun-vade ısı yalıtım performansını %20-30 mertebesinde korur (nem alımı kayıplarını önler). UL 1709 hidrokarbon yangın testinde reçine karbonize char ile 90+ dakika koruma süresi sağlar — offshore platform ve petrokimya tesisleri için kritik.",
    "compare.params":           "Karşılaştırma Parametreleri",
    "compare.area":             "Alan (m²)",
    "compare.electricity":      "Elektrik (TL/kWh)",
    "compare.heating.duration": "Yıllık Isıtma Süresi",
    "compare.layer":            "Katman",
    "compare.col.material":     "MALZEME",
    "compare.col.delete":       "SİL",
    "compare.cell.r":           "R-DEĞERİ",
    "compare.cell.u":           "U-DEĞERİ",
    "compare.result":           "Sonuç Karşılaştırma",
    "compare.winning":          "KAZANAN: SENARYO",
    "compare.annual":           "Yıllık (kWh)",
    "compare.savings":          "TASARRUF / YIL",
    "compare.calc":             "Hesaplama: Q = U · A · HDD · 24 / 1000 (kWh/yıl). 20 yıllık projeksiyon: {value} potansiyel tasarruf · enerji fiyat artışı dahil değil.",
    "compare.newlayer":         "Yeni Katman",
    "rd.sim.title":               "R&D Simülasyon Paneli · R&D Material Design Engine",
    "rd.sim.desc":                "Akademik literatür modellerine dayalı parametre simülasyonu. Katkı oranlarını değiştirin · termal, yangın ve mekanik tahminler gerçek zamanlı güncellenir.",
    "rd.sim.preset.balanced":     "Dengeli",
    "rd.sim.preset.thermal":      "Max Termal",
    "rd.sim.preset.fire":         "Max Yangın",
    "rd.sim.preset.mech":         "Max Mekanik",
    "rd.sim.slider.graphite":     "Grafit / Karbon Katkı (%)",
    "rd.sim.slider.graphite.help":"↓ λ değeri · Hafif radikal yakalama etkisi",
    "rd.sim.slider.fr":           "Alev Geciktirici (%)",
    "rd.sim.slider.fr.help":      "↑ LOI, ↓ pHRR · ↓ Mekanik dayanım",
    "rd.sim.slider.fiber":        "Lif / Fiber Takviye (%)",
    "rd.sim.slider.fiber.help":   "↑ Çekme & eğilme · Yangın etkisi nötr",
    "rd.sim.slider.density":      "Yoğunluk Değişimi (%)",
    "rd.sim.slider.density.help": "↑ Mekanik · Hafif λ artışı",
    "rd.sim.score.thermal":       "Termal Performans",
    "rd.sim.score.fire":          "Yangın Direnci",
    "rd.sim.score.mech":          "Mekanik Dayanım",
    "rd.sim.tbl.param":           "PARAMETRE",
    "rd.sim.tbl.base":            "BAZ (DENEYSEL)",
    "rd.sim.tbl.pred":            "TAHMİNİ",
    "rd.sim.tbl.diff":            "FARK",
    "rd.sim.tbl.flexural":        "Eğilme (kPa)",
    "rd.sim.tbl.tensile":         "Çekme (kPa)",
    "rd.sim.tbl.compress":        "Basma (kPa)",
    "rd.sim.tbl.emod":            "E-Modül (MPa)",
    "rd.sim.insight.title":       "Optimal Karışım Öngörüsü",
    "rd.sim.insight.balanced":    "Mevcut formülasyon termal ve yangın dengesini sağlıyor. Cephe mantolama sistemleri için uygun. ",
    "rd.sim.insight.thermal":     "Yüksek termal performans elde edildi — ancak yangın direnci hedef altında. Cephe yüksekliği ve yangın yönetmeliğine göre değerlendirin. ",
    "rd.sim.insight.fire":        "Üstün yangın direnci — termal performans orta seviyede. Yüksek yapılar veya kaçış koridorları için ideal. ",
    "rd.sim.insight.below":       "Karışım hedef-altı. 'Dengeli' veya 'Max Yangın' preset'ini deneyin.",
    "rd.sim.insight.hint":        "Hedef U<0.30 W/m²K için λ ≈ 0.030 + 5 cm kalınlık önerilir; yangın için LOI ≥ 28.",
    "rd.sim.insight.graphite":    "GRAFİT",
    "rd.sim.insight.fr":          "ALEV GEC.",
    "rd.sim.insight.fiber":       "LİF",
    "rd.sim.insight.densityDelta":"YOĞUNLUK Δ",
    "rd.sim.warn.label":          "UYARI · Tahmini Değerler:",
    "rd.sim.warn.body":           "Bu değerler akademik araştırma modellerine (Schartel 2010 · Wilkie 2010 · Pielichowska 2014) dayanan tahminlerdir. Üretim kararı öncesinde mutlaka laboratuvar testi (ISO 5660-1, ASTM D3801, TS EN 12089) gereklidir. Veriler yalnızca formülasyon yönlendirmesi içindir, yasal/regülatör uyumluluk garantisi sağlamaz.",
    "rd.sim.unchanged":           "değişmedi",
    "pur.title":                  "PUR/PIR Modülü · HFO ↔ HFC Köpürtücü + BiCAT Katalizör",
    "pur.desc":                   "AB F-Gas tüzüğü ile yüksek-GWP HFC köpürtücülerin yerini düşük-GWP HFO (Honeywell Solstice · Chemours Opteon) almaktadır. BiCAT (bizmut katalizör) ise tinin yerine geçen kurşunsuz, hücre yapısı homojen alternatif — ISO 844 basma dayanımını %15-25 artırır.",
    "pur.agent.hfc.label":        "Eski nesil — fazlandırılıyor",
    "pur.agent.hfo.label":        "Yeni nesil · düşük GWP",
    "pur.slider":                 "BiCAT Bizmut Katalizör (ppm)",
    "pur.cell.lambda":            "λ EFEKTİF",
    "pur.cell.compress":          "BASMA (ISO 844)",
    "pur.cell.flexural":          "EĞİLME",
    "pur.cell.reaction":          "REAKSİYON",
    "pur.cell.reaction.unit":     "saniye",
    "pur.chart.lambda":           "λ Sıcaklık Bağımlılığı · HFC vs HFO",
    "pur.chart.compress":         "ISO 844 Basma Dayanımı · BiCAT yüklemesi",
    "pur.note.title":             "Hoca'nın Notu · F-Gas Geçişi",
    "pur.note.body":              "2026 itibariyle AB F-Gas tüzüğü PUR/PIR sektöründe HFC köpürtücüleri tamamen dışlamaktadır. HFO-1233zd(E) λ değerini %10 iyileştirirken, GWP'yi 1030 → 1 mertebesinde düşürür. BiCAT katalizör, kalay (Sn) bazlı eski sistemlerin REACH kapsamında çıkışıyla kritik hale geldi — hücre homojenitesi ile ISO 844 basma dayanımını +%25 artırır.",
    "gw.title":                   "Cam Yünü Modülü · Formaldehit-Free Binder Analizi",
    "gw.desc":                    "2024-2026 döneminde AB ve ABD formaldehit emisyonlarını kısıtladı. Modern cam yünü üreticileri bio-resin (bitki bazlı) bağlayıcılara geçiyor (Knauf ECOSE, Owens Corning Pure, Johns Manville F-Free). ASTM E84 testi ile alev yayılma indeksi (FSI) ve duman gelişme indeksi (SDI) ölçülür.",
    "gw.binder.bio.name":         "Bio-resin (ECOSE/PURE)",
    "gw.binder.acrylic.name":     "Akrilik (BondTec)",
    "gw.binder.phenolic.name":    "Fenolik (geleneksel)",
    "gw.binder.bio.desc":         "Bitki bazlı şeker türevi · formaldehit yok · Cradle-to-Cradle Silver",
    "gw.binder.acrylic.desc":     "Termoset akrilik · düşük emisyon · standart performans",
    "gw.binder.phenolic.desc":    "Standart fenol-formaldehit · 2027 sonrası AB kısıtlı",
    "gw.slider":                  "Bağlayıcı İçeriği (%)",
    "gw.cell.class":              "SINIF",
    "gw.chart.compare":           "Bağlayıcı Karşılaştırma · FSI & SDI",
    "gw.note.title":              "Hoca'nın Notu · Bio-Resin Geçişi",
    "gw.note.body":               "Bio-resin (bitki bazlı şeker türevi) bağlayıcılar, formaldehit emisyonunu sıfıra indirirken yangın performansını korur — ASTM E84 FSI değerleri Class A (≤25) bandında kalır. LEED v4.1 ve WELL Building Standard projelerinde sertifika gerekliliği nedeniyle 2027 sonrası pazar payı %60+ bekleniyor.",
    "eps.bor.name":               "Bor Bileşikleri",
    "eps.matrix.label":           "MATRİS",
    "eps.matrix.val":             "Genleştirilmiş Polistiren (EPS)",
    "eps.load.label":             "TOPLAM KATKI YÜKÜ",
    "eps.load.high":              "⚠ Yüksek (filler limiti)",
    "eps.load.mid":               "Orta seviye",
    "eps.load.low":               "Konservatif",
    "eps.fireclass.label":        "YANGIN SINIFI (TAHMİNİ)",
    "eps.injection":              "ADDITIVE INJECTION · KÜTLE % (m/m)",
    "eps.result.flexural":        "Eğilme",
    "eps.result.tensile":         "Çekme",
    "eps.result.density":         "Yoğunluk",
    "eps.sweep.hint":             "Diğer katkılar sabit · tek değişken sweep",
    "eps.spark.flexural":         "Eğilme (kPa)",
    "eps.warn.label":             "SİMÜLASYON UYARISI:",
    "eps.warn.body":              "Bu veriler akademik araştırmalar ve literatür eğilimleri baz alınarak hazırlanmış simülasyon öngörüleridir. Schmied (2018) · Du (2010) · Stankovich (2006) · ZnB literatürü. Nihai üretim öncesi laboratuvar onayı (ISO 5660-1, ASTM D3801, TS EN 12089) zorunludur.",
    "pricing.note":               "⚠ Endikatif fiyatlandırma — Q1 2026 spot tedarikçi ortalamaları. EPS 17 kg/m³ yoğunluk ve 10 cm panel kalınlığı varsayımı ile (m²×kalınlık×yoğunluk = 1.7 kg/m²).",
  },
  // ────────────────────────────────────────────────────────────────────
  // Core language packs (DE/FR/ES/RU/AR/ZH/JA/PT/IT/KO/HI/NL/PL/SV/NO/DA/FI/EL)
  // — only navigation + critical engineering labels are translated here.
  // Any other key automatically falls back to the English string via the
  // `STRINGS.en[key] ?? fallback ?? key` chain in the t() implementation.
  // ────────────────────────────────────────────────────────────────────
  de: {
    "tab.calc": "Berechnung", "tab.material": "Material", "tab.advisor": "Smart Advisor",
    "tab.rd": "F&E-Labor", "tab.fire": "Flammschutz", "tab.suppliers": "Lieferanten",
    "tab.library": "Bibliothek", "tab.ekonomi": "FINANZEN", "tab.maliyet": "Kosten",
    "tab.compare": "Vergleich", "tab.projects": "Mein Projekt", "tab.standards": "Normen",
    "wizard.country": "LAND", "wizard.climate": "KLIMA", "wizard.space": "RAUM",
    "wizard.dimensions": "ABMESSUNGEN", "wizard.materials": "MATERIALIEN",
    "wizard.cost": "KOSTEN", "wizard.finans": "FINANZEN", "wizard.suppliers": "LIEFERANTEN",
    "rdLab.hero.title": "Akademische Analyse & Testergebnisse",
    "rdLab.note.title": "Professornotiz · Akademischer Forschungskommentar",
    "eps.warn.label": "SIMULATIONSWARNUNG:",
    "pricing.note": "⚠ Indikative Preisgestaltung — Q1 2026 Spot-Lieferanten-Durchschnittspreise. Basierend auf einer Dichte von 17 kg/m³ EPS und einer Paneldicke von 10 cm (m²×Dicke×Dichte = 1,7 kg/m²).",
  },
  fr: {
    "tab.calc": "Calcul", "tab.material": "Matériau", "tab.advisor": "Conseiller IA",
    "tab.rd": "Labo R&D", "tab.fire": "Retardateurs de Flamme", "tab.suppliers": "Fournisseurs",
    "tab.library": "Bibliothèque", "tab.ekonomi": "FINANCE", "tab.maliyet": "Coût",
    "tab.compare": "Comparaison", "tab.projects": "Mon projet", "tab.standards": "Normes",
    "wizard.country": "PAYS", "wizard.climate": "CLIMAT", "wizard.space": "ESPACE",
    "wizard.dimensions": "DIMENSIONS", "wizard.materials": "MATÉRIAUX",
    "wizard.cost": "COÛT", "wizard.finans": "FINANCE", "wizard.suppliers": "FOURNISSEURS",
    "rdLab.hero.title": "Analyse Académique & Résultats des Tests",
    "rdLab.note.title": "Note du Professeur · Commentaire de Recherche Académique",
    "eps.warn.label": "AVERTISSEMENT DE SIMULATION :",
    "pricing.note": "⚠ Tarification indicative — moyennes des fournisseurs spot du T1 2026. Basée sur une hypothèse de densité EPS de 17 kg/m³ et d'épaisseur de panneau de 10 cm (m²×épaisseur×densité = 1,7 kg/m²).",
  },
  es: {
    "tab.calc": "Cálculo", "tab.material": "Material", "tab.advisor": "Asesor IA",
    "tab.rd": "Laboratorio I+D", "tab.fire": "Retardantes de Llama", "tab.suppliers": "Proveedores",
    "tab.library": "Biblioteca", "tab.ekonomi": "FINANZAS", "tab.maliyet": "Costo",
    "tab.compare": "Comparación", "tab.projects": "Mi proyecto", "tab.standards": "Normas",
    "wizard.country": "PAÍS", "wizard.climate": "CLIMA", "wizard.space": "ESPACIO",
    "wizard.dimensions": "DIMENSIONES", "wizard.materials": "MATERIALES",
    "wizard.cost": "COSTO", "wizard.finans": "FINANZAS", "wizard.suppliers": "PROVEEDORES",
    "rdLab.hero.title": "Análisis Académico & Resultados de Pruebas",
    "rdLab.note.title": "Nota del Profesor · Comentario de Investigación Académica",
    "eps.warn.label": "ADVERTENCIA DE SIMULACIÓN:",
    "pricing.note": "⚠ Precios indicativos — promedios de proveedores spot del Q1 2026. Basado en una densidad de EPS de 17 kg/m³ y un espesor de panel de 10 cm (m²×espesor×densidad = 1,7 kg/m²).",
  },
  ru: {
    "tab.calc": "Расчёт", "tab.material": "Материал", "tab.advisor": "ИИ-консультант",
    "tab.rd": "Лаборатория НИОКР", "tab.fire": "Антипирены", "tab.suppliers": "Поставщики",
    "tab.library": "Библиотека", "tab.ekonomi": "ФИНАНСЫ", "tab.maliyet": "Стоимость",
    "tab.compare": "Сравнение", "tab.projects": "Мой проект", "tab.standards": "Стандарты",
    "wizard.country": "СТРАНА", "wizard.climate": "КЛИМАТ", "wizard.space": "ПОМЕЩЕНИЕ",
    "wizard.dimensions": "РАЗМЕРЫ", "wizard.materials": "МАТЕРИАЛЫ",
    "wizard.cost": "СТОИМОСТЬ", "wizard.finans": "ФИНАНСЫ", "wizard.suppliers": "ПОСТАВЩИКИ",
    "rdLab.hero.title": "Академический анализ и результаты испытаний",
    "rdLab.note.title": "Заметка Профессора · Академический исследовательский комментарий",
    "eps.warn.label": "ПРЕДУПРЕЖДЕНИЕ СИМУЛЯЦИИ:",
    "pricing.note": "⚠ Индикативное ценообразование — средние спотовые цены поставщиков Q1 2026. На основе плотности EPS 17 кг/м³ и толщины панели 10 см (м²×толщина×плотность = 1,7 кг/м²).",
  },
  ar: {
    "tab.calc": "حساب", "tab.material": "مادة", "tab.advisor": "المستشار الذكي",
    "tab.rd": "مختبر البحث والتطوير", "tab.fire": "مثبطات اللهب", "tab.suppliers": "الموردون",
    "tab.library": "المكتبة", "tab.ekonomi": "المالية", "tab.maliyet": "التكلفة",
    "tab.compare": "مقارنة", "tab.projects": "مشروعي", "tab.standards": "المعايير",
    "wizard.country": "البلد", "wizard.climate": "المناخ", "wizard.space": "الفضاء",
    "wizard.dimensions": "الأبعاد", "wizard.materials": "المواد",
    "wizard.cost": "التكلفة", "wizard.finans": "المالية", "wizard.suppliers": "الموردون",
    "rdLab.hero.title": "تحليل أكاديمي ونتائج الاختبارات",
    "rdLab.note.title": "ملاحظة الأستاذ · تعليق بحث أكاديمي",
    "eps.warn.label": "تحذير المحاكاة:",
    "pricing.note": "⚠ تسعير إرشادي — متوسطات الموردين الفوريين للربع الأول 2026. بناءً على افتراض كثافة EPS 17 كجم/م³ وسماكة لوحة 10 سم (م²×السماكة×الكثافة = 1.7 كجم/م²).",
  },
  zh: {
    "tab.calc": "计算", "tab.material": "材料", "tab.advisor": "智能顾问",
    "tab.rd": "研发实验室", "tab.fire": "阻燃剂", "tab.suppliers": "供应商",
    "tab.library": "资料库", "tab.ekonomi": "金融", "tab.maliyet": "成本",
    "tab.compare": "比较", "tab.projects": "我的项目", "tab.standards": "标准",
    "wizard.country": "国家", "wizard.climate": "气候", "wizard.space": "空间",
    "wizard.dimensions": "尺寸", "wizard.materials": "材料",
    "wizard.cost": "成本", "wizard.finans": "金融", "wizard.suppliers": "供应商",
    "rdLab.hero.title": "学术分析与测试结果",
    "rdLab.note.title": "教授笔记 · 学术研究评论",
    "eps.warn.label": "模拟警告：",
    "pricing.note": "⚠ 指示性定价 — 2026年第一季度现货供应商平均价格。基于 EPS 17 kg/m³ 密度和 10 cm 面板厚度假设 (m²×厚度×密度 = 1.7 kg/m²)。",
  },
  ja: {
    "tab.calc": "計算", "tab.material": "材料", "tab.advisor": "AIアドバイザー",
    "tab.rd": "R&Dラボ", "tab.fire": "難燃剤", "tab.suppliers": "サプライヤー",
    "tab.library": "ライブラリ", "tab.ekonomi": "ファイナンス", "tab.maliyet": "コスト",
    "tab.compare": "比較", "tab.projects": "マイプロジェクト", "tab.standards": "規格",
    "wizard.country": "国", "wizard.climate": "気候", "wizard.space": "空間",
    "wizard.dimensions": "寸法", "wizard.materials": "材料",
    "wizard.cost": "コスト", "wizard.finans": "ファイナンス", "wizard.suppliers": "サプライヤー",
    "rdLab.hero.title": "学術分析とテスト結果",
    "rdLab.note.title": "教授ノート · 学術研究コメント",
    "eps.warn.label": "シミュレーション警告:",
    "pricing.note": "⚠ 参考価格 — 2026年第1四半期スポット仕入先平均。EPS 17 kg/m³ 密度と10cmパネル厚の仮定に基づく (m²×厚さ×密度 = 1.7 kg/m²)。",
  },
  pt: { "tab.calc": "Cálculo", "tab.material": "Material", "tab.rd": "Lab. P&D", "tab.advisor": "Consultor IA", "tab.suppliers": "Fornecedores", "tab.library": "Biblioteca", "tab.compare": "Comparação", "tab.projects": "Meu projeto", "tab.standards": "Normas" },
  it: { "tab.calc": "Calcolo", "tab.material": "Materiale", "tab.rd": "Lab. R&S", "tab.advisor": "Consulente IA", "tab.suppliers": "Fornitori", "tab.library": "Biblioteca", "tab.compare": "Confronto", "tab.projects": "Mio progetto", "tab.standards": "Norme" },
  ko: { "tab.calc": "계산", "tab.material": "재료", "tab.rd": "R&D 연구소", "tab.advisor": "AI 어드바이저", "tab.suppliers": "공급업체", "tab.library": "라이브러리", "tab.compare": "비교", "tab.projects": "내 프로젝트", "tab.standards": "표준" },
  hi: { "tab.calc": "गणना", "tab.material": "सामग्री", "tab.rd": "R&D लैब", "tab.advisor": "AI सलाहकार", "tab.suppliers": "आपूर्तिकर्ता", "tab.library": "पुस्तकालय", "tab.compare": "तुलना", "tab.projects": "मेरी परियोजना", "tab.standards": "मानक" },
  nl: { "tab.calc": "Berekening", "tab.material": "Materiaal", "tab.rd": "R&D-Lab", "tab.advisor": "AI-Adviseur", "tab.suppliers": "Leveranciers", "tab.library": "Bibliotheek", "tab.compare": "Vergelijking", "tab.projects": "Mijn project", "tab.standards": "Normen" },
  pl: { "tab.calc": "Obliczenia", "tab.material": "Materiał", "tab.rd": "Lab. B+R", "tab.advisor": "Doradca AI", "tab.suppliers": "Dostawcy", "tab.library": "Biblioteka", "tab.compare": "Porównanie", "tab.projects": "Mój projekt", "tab.standards": "Normy" },
  sv: { "tab.calc": "Beräkning", "tab.material": "Material", "tab.rd": "FoU-lab", "tab.advisor": "AI-Rådgivare", "tab.suppliers": "Leverantörer", "tab.library": "Bibliotek", "tab.compare": "Jämförelse", "tab.projects": "Mitt projekt", "tab.standards": "Standarder" },
  no: { "tab.calc": "Beregning", "tab.material": "Materiale", "tab.rd": "FoU-lab", "tab.advisor": "AI-Rådgiver", "tab.suppliers": "Leverandører", "tab.library": "Bibliotek", "tab.compare": "Sammenligning", "tab.projects": "Mitt prosjekt", "tab.standards": "Standarder" },
  da: { "tab.calc": "Beregning", "tab.material": "Materiale", "tab.rd": "F&U-lab", "tab.advisor": "AI-Rådgiver", "tab.suppliers": "Leverandører", "tab.library": "Bibliotek", "tab.compare": "Sammenligning", "tab.projects": "Mit projekt", "tab.standards": "Standarder" },
  fi: { "tab.calc": "Laskenta", "tab.material": "Materiaali", "tab.rd": "T&K-labra", "tab.advisor": "AI-Neuvoja", "tab.suppliers": "Toimittajat", "tab.library": "Kirjasto", "tab.compare": "Vertailu", "tab.projects": "Projektini", "tab.standards": "Standardit" },
  el: { "tab.calc": "Υπολογισμός", "tab.material": "Υλικό", "tab.rd": "Εργαστήριο Ε&Α", "tab.advisor": "Σύμβουλος AI", "tab.suppliers": "Προμηθευτές", "tab.library": "Βιβλιοθήκη", "tab.compare": "Σύγκριση", "tab.projects": "Το έργο μου", "tab.standards": "Πρότυπα" },
};

const STANDARDS = {
  TR:       { id: "TR",       label: "TR · TS 825:2024",      r_si: 0.13, r_se: 0.04, note: "Türkiye Binalarda Isı Yalıtım Kuralları" },
  EU:       { id: "EU",       label: "EU · EN ISO 6946",      r_si: 0.13, r_se: 0.04, note: "European Standard EN ISO 6946" },
  DIN:      { id: "DIN",      label: "DE · DIN 4108-2",       r_si: 0.13, r_se: 0.04, note: "Thermal Insulation + Moisture Control · Isı Yalıtımı + Nem Kontrolü" },
  DIN_FIRE: { id: "DIN_FIRE", label: "DE · DIN 4102-1",       r_si: 0.13, r_se: 0.04, note: "Fire Behaviour of Building Materials · Yapı Malzemelerinin Yangın Davranışı" },
  EPS_EN:   { id: "EPS_EN",   label: "TR/EU · TS EN 13163",   r_si: 0.13, r_se: 0.04, note: "Factory-made EPS Insulation · Fabrika Yapımı EPS Yalıtım Özellikleri" },
  US:       { id: "US",       label: "US · ASTM C518/ASHRAE", r_si: 0.11, r_se: 0.03, note: "ASTM C518 · ASHRAE Fundamentals" },
};

// Turkish display aliases for country names keyed by ISO-2 code.
// Used by the country dropdown so TR users see localised names (and EN users see English).
const COUNTRY_TR = {
  US: "ABD / Amerika",
  GB: "Birleşik Krallık",
  DE: "Almanya",
  FR: "Fransa",
  BE: "Belçika",
  NL: "Hollanda",
  IT: "İtalya",
  ES: "İspanya",
  RU: "Rusya",
  JP: "Japonya",
  CN: "Çin",
  KR: "Güney Kore",
  AE: "BAE",
  SA: "Suudi Arabistan",
  TR: "Türkiye",
  GR: "Yunanistan",
  PT: "Portekiz",
  IE: "İrlanda",
  CZ: "Çekya",
  HU: "Macaristan",
  RO: "Romanya",
  BG: "Bulgaristan",
  PL: "Polonya",
  UA: "Ukrayna",
  IL: "İsrail",
  QA: "Katar",
  EG: "Mısır",
  ZA: "Güney Afrika",
  NG: "Nijerya",
  KE: "Kenya",
  MA: "Fas",
  TH: "Tayland",
  VN: "Vietnam",
  ID: "Endonezya",
  MY: "Malezya",
  SG: "Singapur",
  PH: "Filipinler",
  AU: "Avustralya",
  NZ: "Yeni Zelanda",
  AZ: "Azerbaycan",
  KZ: "Kazakistan",
  GE: "Gürcistan",
  IR: "İran",
  PK: "Pakistan",
  CA: "Kanada",
  MX: "Meksika",
  BR: "Brezilya",
  AR: "Arjantin",
  IN: "Hindistan",
  CH: "İsviçre",
  AT: "Avusturya",
  SE: "İsveç",
  NO: "Norveç",
  DK: "Danimarka",
  FI: "Finlandiya",
};

export function tCountry(country, lang) {
  if (!country) return "";
  // Both languages: render the US as "Amerika".
  if (country.code === "US") return "Amerika";
  if (lang === "tr" && COUNTRY_TR[country.code]) return COUNTRY_TR[country.code];
  return country.name;
}

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("en");      // DEFAULT ENGLISH
  const [standard, setStandard] = useState("TR");
  const value = useMemo(() => ({
    lang, setLang,
    standard, setStandard,
    standardData: STANDARDS[standard],
    t: (key, fallback) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? fallback ?? key,
  }), [lang, standard]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export const STANDARDS_LIST = Object.values(STANDARDS);
